['DOMContentLoaded', 'pp-some-section-refresh'].forEach((eventName) => {
  document.addEventListener(eventName, function () {
    const parallaxItems = document.querySelectorAll('.parallax-image');

    const updateParallax = (parallaxImage) => {
      const windowHeight = window.innerHeight;
      const scrollPosition = window.scrollY;
      const parentElement = parallaxImage.parentElement.parentElement.getBoundingClientRect();
      const elementTop = parentElement.top + scrollPosition;
      const elementHeight = parentElement.height;
      const maxOffset = 100;

      let elementInView = (scrollPosition + windowHeight - elementTop) / (windowHeight + elementHeight);
      elementInView = Math.min(1, Math.max(0, elementInView));

      const offset = maxOffset * elementInView;

      parallaxImage.style.transform = `translateY(${offset}px)`;
    };

    parallaxItems.forEach((image) => {
      window.addEventListener('scroll', () => updateParallax(image));
    });
  });
});
